import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { SelectField, MenuItem } from 'material-ui';
import { updateCReportProps } from '../../stores/contracting-reports/actions';
import ContractsBlackoutReports from './sampleTables/contractsBlackoutsReport';
import TemplatesBlackoutReports from './sampleTables/templatesBlackoutsReport';

const Blackout = props => {
  const {
    updateProps,
    contractingReports,
    companyType,
  } = props;

  const blackoutReportTypes = [
    {
      reportName: 'Templates',
      key: 'templates',
    },
    {
      reportName: 'Contracts',
      key: 'newContracts',
    },
  ];

  return (
    <div style={{ paddingTop: '16px' }}>
      {
        companyType === 'Supplier' && (
          <div className="flex-tc-sb" style={{ width: '60%', marginBottom: '16px' }}>
            <label>Select A Blackout Dates Report Type:</label>
            <SelectField
              value={contractingReports.blackoutReport}
              labelStyle={{ fontSize: '14px' }}
              style={{ marginLeft: '16px' }}
            >
              {
                blackoutReportTypes.map((report, i) => {
                  return (
                    <MenuItem
                      key={i}
                      value={report.key}
                      primaryText={report.reportName}
                      onTouchTap={() => updateProps({ blackoutReport: report.key })}
                    />
                  );
                })
              }
            </SelectField>
          </div>
        )
      }
      {
        companyType === 'Supplier' && contractingReports.blackoutReport === 'templates' ? (
          <TemplatesBlackoutReports/>
        ) : (
          <ContractsBlackoutReports/>
        )
      }
    </div>
  );
};

Blackout.propTypes = {
  updateProps: PropTypes.func,
  contractingReports: PropTypes.object,
  companyType: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  updateProps: (...args) => dispatch(updateCReportProps(...args)),
});

const mapStateToProps = ({ contractingReports }) => ({
  contractingReports: contractingReports.toJS(),
});

export default connect(mapStateToProps, mapDispatchToProps)(Blackout);



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/blackout.jsx